import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=d52ce000&scoped=true&"
import script from "./Sports.vue?vue&type=script&lang=js&"
export * from "./Sports.vue?vue&type=script&lang=js&"
import style0 from "./Sports.vue?vue&type=style&index=0&id=d52ce000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52ce000",
  null
  
)

export default component.exports